import get from 'lodash.get';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'dibs-react-intl';
import { createFragmentContainer, graphql } from 'react-relay/legacy';

// components
import DeliveryOption from '../shared/delivery/DeliveryOption';
import LocalPickupDescription from '../shared/delivery/LocalPickupDescription';

function BuyerLocalPickup({
    item,
    localPickupQuote,
    shipmentType,
    shipmentQuoteId,
    onSelect,
    isComputing,
}) {
    const isSelected =
        shipmentType === 'LOCAL_PICKUP' && shipmentQuoteId === get(localPickupQuote, 'serviceId');
    return (
        <DeliveryOption
            value="LOCAL_PICKUP"
            title={
                <FormattedMessage
                    id="checkout.BuyerLocalPickup.title"
                    defaultMessage="Pick up in person"
                />
            }
            description={<LocalPickupDescription item={item} />}
            testName="LOCAL_PICKUP"
            isSelected={isSelected}
            onSelect={() =>
                onSelect({
                    shipmentType: 'LOCAL_PICKUP',
                    shipmentQuoteId: localPickupQuote.serviceId,
                })
            }
            disabled={isComputing}
        />
    );
}

BuyerLocalPickup.propTypes = {
    item: PropTypes.object.isRequired,
    localPickupQuote: PropTypes.object.isRequired,
    shipmentType: PropTypes.string.isRequired,
    shipmentQuoteId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    isComputing: PropTypes.bool,
};

export default createFragmentContainer(BuyerLocalPickup, {
    item: graphql`
        fragment BuyerLocalPickup_item on Item {
            ...LocalPickupDescription_item
        }
    `,
    localPickupQuote: graphql`
        fragment BuyerLocalPickup_localPickupQuote on ShipmentQuote {
            serviceId
        }
    `,
});
